import fallbacks from "../i18n/locales-fallback-map.json";
import { getCountryLanguageFromLocaleCode } from "../utils/i18n";

const acceptedApiLocales: Record<string, string> = {
  "it-IT": "it-IT",
  "en-GB": "en-GB",
  "fr-FR": "fr-FR",
  "de-DE": "fr-FR",
  "es-ES": "es-ES",
  "tr-TR": "tr-TR",
  "ru-RU": "ru-RU",
  "pt-PT": "pt-PT",
  "zh-CN": "zh-CN",
  "id-ID": "id-ID",
  "ja-JP": "ja-JP",
  "ko-KR": "ko-KR",
  "pt-BR": "pt-PT",
  en: "en-GB",
};

export const getApiLocale = (locale: string): string => {
  // If the current locale is accepted by API or has an immediate fallback
  if (Object.keys(acceptedApiLocales).includes(locale)) {
    return acceptedApiLocales[locale];
  }

  // Else find a fallback from contentful
  const fallback = fallbacks[locale as keyof typeof fallbacks];

  // Check if the fallback is accepted by API using the same process
  if (fallback) {
    return getApiLocale(fallback);
  }

  // Else give up
  return "en-GB";
};

const acceptedApiLocalesForSignIn: Record<string, string> = {
  de: "de",
  en: "en",
  es: "es",
  fr: "fr",
  id: "id",
  it: "it",
  ja: "ja",
  ko: "ko",
  "pt-BR": "pt-br",
  "pt-PT": "pt-pt",
  th: "th",
  tr: "tr",
  vi: "vi",
  "zh-CN": "zh-hans",
};

export const getApiLocalesForSignIn = (locale: string) => {
  // Extract only the language from country-language locale
  const { language } = getCountryLanguageFromLocaleCode(locale);

  // Check if lang is API valid
  if (Object.keys(acceptedApiLocalesForSignIn).includes(language)) return language;

  // Else check if locale is an exception
  if (Object.keys(acceptedApiLocalesForSignIn).includes(locale))
    return acceptedApiLocalesForSignIn[locale];

  // Else give up and fallback to english
  return "en";
};
